import styled from 'styled-components';

export const Cover = styled.div`
    width: 100%;
    height: 0;
    padding-top: 100%;
    background-size: cover;
    background-position: center center;
`;
